import { BfxFindFilterDateComparitor } from "shared/cubiq-services/model/find/BfxFindFilterDateComparitor";

export const BFX_FIND_DATE_COMPARITOR = [
  { label: "Today", value: BfxFindFilterDateComparitor.TODAY },
  { label: "Yesterday", value: BfxFindFilterDateComparitor.YESTERDAY },
  { label: "Last Week", value: BfxFindFilterDateComparitor.LAST_WEEK },
  { label: "Last Month", value: BfxFindFilterDateComparitor.LAST_MONTH },
  { label: "Last Year", value: BfxFindFilterDateComparitor.LAST_YEAR },
];
